import React from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { FloatingAddButton } from '@/components/evidence';

interface AppShellProps {
  children: React.ReactNode;
}

// Pages where the floating add button should appear
const PAGES_WITH_ADD_BUTTON = ['/', '/evidence'];

export function AppShell({ children }: AppShellProps) {
  const location = useLocation();
  const showFloatingButton = PAGES_WITH_ADD_BUTTON.includes(location.pathname);

  return (
    <div className="flex h-screen overflow-hidden bg-white dark:bg-dark-950">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content area */}
      <div className="relative flex flex-1 flex-col overflow-hidden">
        {/* Header */}
        <Header />

        {/* Page content */}
        <main className="flex-1 overflow-auto p-4 lg:p-8">
          <div className="mx-auto max-w-7xl">
            {children}
          </div>
        </main>

        {/* Floating add evidence button */}
        {showFloatingButton && <FloatingAddButton />}
      </div>
    </div>
  );
}
